import { render, staticRenderFns } from "./LinkHeader.vue?vue&type=template&id=31591ee9&scoped=true&"
import script from "./LinkHeader.js?vue&type=script&lang=js&"
export * from "./LinkHeader.js?vue&type=script&lang=js&"
import style0 from "./LinkHeader.scss?vue&type=style&index=0&id=31591ee9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31591ee9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VLayout,VTextField})
